<!-- Folders Page with Left Navigation Layout -->
<div class="folders-left-nav-layout">

  <!-- Left Sidebar: Category Navigation -->
  <aside class="left-nav-sidebar">
    <div class="sidebar-header">
      <h3>Folders</h3>
      <span class="folder-count" *ngIf="categories.length > 0">{{ categories.length }}</span>
    </div>

    <div *ngIf="isLoading" class="sidebar-loading">
      <loading message="loading folders..."></loading>
    </div>

    <nav class="category-nav" *ngIf="!isLoading">
      <div *ngIf="categories.length === 0" class="empty-nav">
        No folders available
      </div>

      <ul class="category-list">
        <li *ngFor="let category of categories"
            class="category-item"
            [class.active]="selectedCategoryId === category.category_id"
            (click)="selectCategory(category.category_id)">
          <div class="category-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2" />
            </svg>
          </div>
          <span class="category-name">{{ category.category_name }}</span>
          <span class="category-badge">{{ category.document_count }}</span>
        </li>
      </ul>
    </nav>
  </aside>

  <!-- Main Content Area -->
  <main class="main-content">

    <!-- Pending Reviews Banner for Managers/Admins -->
    <div *ngIf="pending_review_count > 0 && is_manager_or_higher" class="review-banner review-banner-manager">
      <div class="banner-content">
        <div class="banner-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <div class="banner-text">
          <strong>{{ pending_review_count }} {{ pending_review_count === 1 ? 'document requires' : 'documents require' }} your review</strong>
          <span>Review document separations or classifications before they can be processed.</span>
        </div>
      </div>
      <a routerLink="/files/review" class="btn btn-primary btn-small">Review Now</a>
    </div>

    <!-- Pending Reviews Banner for Regular Users -->
    <div *ngIf="pending_review_count > 0 && !is_manager_or_higher" class="review-banner review-banner-user">
      <div class="banner-content">
        <div class="banner-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        </div>
        <div class="banner-text">
          <span>{{ pending_review_count }} {{ pending_review_count === 1 ? 'file is' : 'files are' }} pending manager review</span>
        </div>
      </div>
    </div>

    <!-- Content Header -->
    <div class="content-header">
      <h1>{{ currentCategoryName }}</h1>
      <p class="content-subtitle" *ngIf="selectedCategoryId">
        Select a document type to view files
      </p>
    </div>

    <!-- Types Section -->
    <div class="types-section" *ngIf="selectedCategoryId">

      <div *ngIf="loadingTypes" class="types-loading">
        <loading message="loading types..."></loading>
      </div>

      <div *ngIf="!loadingTypes && types.length === 0" class="types-empty">
        <p>No document types available in this folder</p>
      </div>

      <div *ngIf="!loadingTypes && types.length > 0" class="types-grid">
        <div *ngFor="let type of types"
             class="type-card"
             [class.empty]="type.document_count === 0"
             [class.selected]="selectedTypeId === type.type_id"
             (click)="toggleType(type.type_id, type.document_count)">
          <div class="type-card-header">
            <div class="type-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2" />
              </svg>
            </div>
            <span class="type-name">{{ type.type_name }}</span>
          </div>
          <div class="type-card-footer">
            <span class="file-count">{{ type.document_count }} {{ type.document_count === 1 ? 'file' : 'files' }}</span>
            <div class="expand-hint" *ngIf="type.document_count > 0">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="selectedTypeId === type.type_id">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Files Section -->
    <div class="files-section" *ngIf="selectedTypeId">

      <div *ngIf="loadingFiles" class="files-loading">
        <loading message="loading files..."></loading>
      </div>

      <div *ngIf="!loadingFiles && files.length === 0" class="files-empty">
        <p>No files found for this document type</p>
      </div>

      <div *ngIf="!loadingFiles && files.length > 0" class="files-container">
        <div class="files-table-header">
          <h3>Files</h3>
          <span class="files-count">{{ totalFilesForType }} total</span>
        </div>

        <div class="files-list">
          <div *ngFor="let file of files" class="file-row" (click)="selectFile(file.id)">
            <div class="file-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            </div>
            <div class="file-info">
              <span class="file-name">{{ file.name }}</span>
              <span class="file-meta">{{ file.extension.toUpperCase() || 'FILE' }} • {{ file.uploadedAt | date:'mediumDate' }}</span>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div class="pagination-footer">
          <div class="pagination-info">
            <p>Showing {{ showingFrom }}–{{ showingTo }} of {{ totalFilesForType }} files</p>
          </div>
          <div class="pagination-controls">
            <button class="btn btn-secondary btn-small" (click)="firstPage()" [disabled]="currentPageForType === 1">
              « First
            </button>
            <button class="btn btn-secondary btn-small" (click)="prevPage()" [disabled]="currentPageForType === 1">
              ‹ Prev
            </button>
            <span class="page-indicator">Page {{ currentPageForType }} of {{ totalPages }}</span>
            <button class="btn btn-secondary btn-small" (click)="nextPage()" [disabled]="currentPageForType === totalPages || totalPages === 0">
              Next ›
            </button>
            <button class="btn btn-secondary btn-small" (click)="lastPage()" [disabled]="currentPageForType === totalPages || totalPages === 0">
              Last »
            </button>
            <div class="page-size">
              <label for="pageSize">Per page</label>
              <select id="pageSize" [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State (no category selected) -->
    <div *ngIf="!selectedCategoryId && !isLoading" class="empty-state">
      <div class="empty-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2" />
        </svg>
      </div>
      <p>Select a folder from the sidebar to view documents</p>
    </div>

  </main>

  <!-- File Sidebar -->
  <app-file-sidebar [fileId]="selectedFileId" [isOpen]="isSidebarOpen" (close)="closeSidebar()">
  </app-file-sidebar>

</div>
